import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { notifyTopRight, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import { db } from "../../../firebase";
import { setDoc, doc } from "firebase/firestore";
import { NodeForm } from "./NodeForm";
import "./NodeList.css";
import { getNodeSharedRoomCount, parseNodeSharedRoomCount } from "./nodeDirectoryUtils";

const NodeRegister = (props) => {
  const inputRef = useRef({
    nodeIndex: "",
    nodecode: "",
    nodename: "",
    dueDays: "",
    sharedRoomCount: "",
  });
  const [availabilityStatus, setAvailabilityStatus] = useState("available");
  const [sharedRoomCountInput, setSharedRoomCountInput] = useState("");
  const sharedRoomsEdited = useRef(false);

  useEffect(() => {
    if (props.show) {
      inputRef.current = { nodeIndex: "", nodecode: "", nodename: "", dueDays: "", sharedRoomCount: "" };
      setAvailabilityStatus("available");
      setSharedRoomCountInput("");
      sharedRoomsEdited.current = false;
    }
  }, [props.show]);

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
    if (name === "sharedRoomCount") {
      sharedRoomsEdited.current = true;
      setSharedRoomCountInput(e.target.value);
    } else if (["nodecode", "nodename"].includes(name) && !sharedRoomsEdited.current) {
      const count = getNodeSharedRoomCount({ ...inputRef.current, sharedRoomCount: null });
      inputRef.current.sharedRoomCount = count == null ? "" : String(count);
      setSharedRoomCountInput(inputRef.current.sharedRoomCount);
    }
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let sharedRoomCount;
    try { sharedRoomCount = parseNodeSharedRoomCount(inputRef.current.sharedRoomCount, inputRef.current); }
    catch (error) { notifyError(error.message); return; }

    const formData = {
      nodeIndex: inputRef.current.nodeIndex.trim() || "",
      nodecode: inputRef.current.nodecode.trim() || "",
      nodename: inputRef.current.nodename.trim() || "",
      dueDays: inputRef.current.dueDays.trim() || "",
      sharedRoomCount,
      availabilityStatus,
    };

    if (
      !formData.nodeIndex ||
      !formData.nodecode ||
      !formData.nodename ||
      !formData.dueDays
    ) {
      notifyError("กรุณากรอกข้อมูลให้ครบ");
      return;
    }

    try {
      const ref = doc(db, "nodes", formData.nodename);
      await setDoc(ref, formData);
      notifyTopRight("บันทึกข้อมูลสำเร็จ");
      props.item({ id: formData.nodename, ...formData, customers: [] });
      props.hide();
    } catch (err) {
      notifyError("บันทึกข้อมูลผิดพลาด", err.message || err);
    }

    console.log(formData);
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="node-editor"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new node</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <NodeForm
            onChange={handleChange}
            sharedRoomCount={sharedRoomCountInput}
            availabilityStatus={availabilityStatus}
            onAvailabilityChange={(event) => setAvailabilityStatus(event.target.value)}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit}>Save</Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default NodeRegister;
